import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, EyeIcon, MessageSquareIcon } from 'lucide-react';
export function MethodSection() {
  const features = [{
    icon: SparklesIcon,
    title: 'Traducción Espejo',
    description: 'Entrena tu oído para reconocer palabras clave en inglés y conectarlas instantáneamente con su significado en español.'
  }, {
    icon: EyeIcon,
    title: 'Anclajes Visuales',
    description: 'Las fechas históricas se vuelven imposibles de olvidar con nuestro sistema de anclaje visual.'
  }, {
    icon: MessageSquareIcon,
    title: 'Frases de Rescate',
    description: 'Sabes exactamente qué decir si no entiendes al oficial, demostrando dominio del idioma en lugar de pánico.'
  }];
  return <section className="w-full bg-[#1B2A4A] text-white" data-id="element-129">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-131">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6 text-center" data-id="element-132">
            El Método de Traducción Espejo y Anclaje Visual
          </h2>

          <p className="text-xl text-gray-200 mb-12 text-center max-w-3xl mx-auto" data-id="element-133">
            Este sistema no solo te da la pregunta y la respuesta; entrena tu
            oído para reconocer palabras clave en inglés y conectarlas
            instantáneamente con su significado en español.
          </p>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-134">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white/10 backdrop-blur-sm p-6 rounded-lg border-2 border-[#C9A84C]" data-id="element-135">
                <feature.icon className="w-12 h-12 text-[#C9A84C] mb-4" data-id="element-136" />
                <h3 className="text-xl font-bold mb-3 text-[#C9A84C]" data-id="element-137">
                  {feature.title}
                </h3>
                <p className="text-gray-200" data-id="element-138">{feature.description}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}